<div class="tooltip flex-row space-between ws-nowrap" [style.left]="left + 'px'" [style.top]="top + 'px'">
     <div class="flex-col flex-1 text-bold">
          <span>Reserve Credit: </span>
          <span>Client Reserve: </span>
          <span>Buyer Premium: </span>
          <span>Min Reserve: </span>
          <span>BP Coverage: </span>
          <span>Expenses: </span>
     </div>
     <div class="flex-col flex-1 ml-2">
          @if(bpSpreadData.reserveCredit>0){
               <span [class]="(bpSpreadData.reserveDifference +  bpSpreadData.reserveCredit)>=0?'green':'red'">{{bpSpreadData.reserveCredit | currency:'USD':'symbol':'1.2-2'}} | Effective Reserve {{bpSpreadData.effectiveReserve| currency:'USD':'symbol':'1.2-2'}} <a href="javascript:void(0)" (click)="onEditReserveCreditClicked()" class="uppercase red">Edit</a></span>
          }
          @if(bpSpreadData.reserveCredit==0){
               <a class="uppercase green" href="javascript:void(0)" (click)="onEditReserveCreditClicked()">Apply Reserve Credit</a>
          }       
          <span class="flex-row">
               <span>{{bpSpreadData.clientReserve | currency:'USD':'symbol':'1.2-2'}}</span>
               <span class="mx-1">|</span>
               <span [class]="bpSpreadData.reserveDifference>=0?'green':'red'">{{bpSpreadData.reserveDifference | currency:'USD':'symbol':'1.2-2'}}</span>
          </span>
          <span>{{bpSpreadData.auction!.buyerPremium!/100 | percent}}</span>
          <span>{{bpSpreadData.minimumReserve | currency:'USD':'symbol':'1.2-2'}}</span>
          <span [class]="bpSpreadData.bpSpread>=0?'green':'red'">{{bpSpreadData.bpSpread | currency:'USD':'symbol':'1.2-2'}} | {{bpSpreadData.bpEffective | currency:'USD':'symbol':'1.2-2'}}</span>
          <span>{{bpSpreadData.propertyExpensesTotal | currency:'USD':'symbol':'1.2-2'}}</span>
     </div>
</div>